import { render, staticRenderFns } from "./StrategyMatchesModal.vue?vue&type=template&id=6c1ab886&scoped=true&"
import script from "./StrategyMatchesModal.vue?vue&type=script&lang=js&"
export * from "./StrategyMatchesModal.vue?vue&type=script&lang=js&"
import style0 from "./StrategyMatchesModal.vue?vue&type=style&index=0&id=6c1ab886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ab886",
  null
  
)

export default component.exports